import React, { useState, Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CheckCircleIcon, XCircleIcon, DownloadIcon } from 'lucide-react';
import { FormSection, DisplayField, TextAreaField } from '../components/FormComponents';
import { StatusBadge } from '../components/StatusBadge';
import { mockRequisitions } from '../data/mockData';
export function RequisitionApprovalAction() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const [remarks, setRemarks] = useState('');
  const data = mockRequisitions.find(r => r.id === id);
  if (!data) return <div data-id="element-1937">Record not found</div>;
  const handleAction = (action: 'approve' | 'reject') => {
    if (action === 'reject' && !remarks) {
      alert('Remarks are mandatory for rejection.');
      return;
    }
    alert(`Successfully ${action}d!`);
    navigate(-1);
  };
  return <div className="space-y-6 max-w-5xl mx-auto" data-id="element-1938">
      <div className="flex items-center justify-between" data-id="element-1939">
        <div data-id="element-1940">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1941">
            Requisition Approval
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1942">
            Review details and take action.
          </p>
        </div>
        <StatusBadge status={data.status} className="text-sm px-3 py-1" data-id="element-1943" />
      </div>

      <div className="bg-white shadow-sm rounded-lg border border-gray-200 p-6 md:p-8 space-y-8" data-id="element-1944">
        <FormSection title="Requisition Details" data-id="element-1945">
          <DisplayField label="REQ No" value={data.reqNo} data-id="element-1946" />
          <DisplayField label="Originator" value={data.requestedBy} data-id="element-1947" />
          <DisplayField label="Department" value={data.department} data-id="element-1948" />
          <DisplayField label="Req. For" value={data.reqFor} data-id="element-1949" />
          {data.employee && <DisplayField label="Employee" value={data.employee} data-id="element-1950" />}
          <DisplayField label="Required Date" value={data.requiredDate} data-id="element-1951" />
        </FormSection>

        <div className="mb-8" data-id="element-1952">
          <h3 className="text-lg font-medium text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-1953">
            Items
          </h3>
          <div className="overflow-x-auto" data-id="element-1954">
            <table className="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-md" data-id="element-1955">
              <thead className="bg-gray-50" data-id="element-1956">
                <tr data-id="element-1957">
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1958">
                    Item
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1959">
                    Qty
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1960">
                    Purpose
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1961">
                {data.items.map((item: any) => <tr key={item.id} data-id="element-1962">
                    <td className="px-4 py-2 text-sm text-gray-900" data-id="element-1963">
                      {item.item}
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-500" data-id="element-1964">
                      {item.qty}
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-500" data-id="element-1965">
                      {item.purpose}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <FormSection title="Attachments" data-id="element-1966">
          <div className="md:col-span-2" data-id="element-1967">
            <button className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-1968">
              <DownloadIcon className="h-4 w-4 mr-2 text-gray-500" data-id="element-1969" />
              Download Supporting Documents.zip
            </button>
          </div>
        </FormSection>

        <div className="border-t border-gray-200 pt-8" data-id="element-1970">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1971">
            Approval Action
          </h3>
          <TextAreaField label="Approver Remarks" name="remarks" value={remarks} onChange={e => setRemarks(e.target.value)} placeholder="Enter remarks (mandatory for rejection)..." rows={3} data-id="element-1972" />

          <div className="mt-6 flex space-x-4" data-id="element-1973">
            <button onClick={() => handleAction('approve')} className="flex-1 inline-flex justify-center items-center px-4 py-3 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700" data-id="element-1974">
              <CheckCircleIcon className="h-5 w-5 mr-2" data-id="element-1975" /> Approve
            </button>
            <button onClick={() => handleAction('reject')} className="flex-1 inline-flex justify-center items-center px-4 py-3 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700" data-id="element-1976">
              <XCircleIcon className="h-5 w-5 mr-2" data-id="element-1977" /> Reject
            </button>
          </div>
        </div>
      </div>
    </div>;
}